/**
 * Copyright © 2026 Adnuntius AS.
 *
 * Signal-backed zoneless template-state utilities. Prefer edit-page phase
 * (`attachEditPagePhase` + viewWrite) on resource edit pages; use these
 * helpers for derived getters, modals, and non-phased hosts.
 */
import {isViewSignal, readViewSignal, writeViewSignal} from './view-signal';

/** Defer signal-backed state past the current template verification pass. */
export function deferSignalStateWrite(apply: () => void): void {
  setTimeout(apply, 0);
}

export {
  isViewSignal,
  readViewSignal,
  writeViewSignal
};
